import { render, staticRenderFns } from "./edit-business-profile.vue?vue&type=template&id=f9a6dffe&scoped=true&"
import script from "./edit-business-profile.vue?vue&type=script&lang=js&"
export * from "./edit-business-profile.vue?vue&type=script&lang=js&"
import style0 from "./edit-business-profile.vue?vue&type=style&index=0&id=f9a6dffe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a6dffe",
  null
  
)

export default component.exports